module.exports = __webpack_public_path__ + "static/media/discord.8f7e0dea.svg";